import { DaysOfWeek, ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

type SlotsHeaderDays = Record<ShortDaysOfWeek, DaysOfWeek>

interface UseSlotDaysOfWeekReturn {
  days: SlotsHeaderDays
}

export const useSlotDaysOfWeek = (): UseSlotDaysOfWeekReturn => {
  const days: SlotsHeaderDays = {
    [ShortDaysOfWeek.Sunday]: DaysOfWeek.Sunday,
    [ShortDaysOfWeek.Monday]: DaysOfWeek.Monday,
    [ShortDaysOfWeek.Tuesday]: DaysOfWeek.Tuesday,
    [ShortDaysOfWeek.Wednesday]: DaysOfWeek.Wednesday,
    [ShortDaysOfWeek.Thursday]: DaysOfWeek.Thursday,
    [ShortDaysOfWeek.Friday]: DaysOfWeek.Friday,
    [ShortDaysOfWeek.Saturday]: DaysOfWeek.Saturday,
  }

  return {
    days,
  }
}
